import React from 'react';
import TrustedBadge from '@/components/common/TrustedBadge';
import { StoreConfModel } from '@/models';
import SecureInfoEspot from '../espots/SecureInfoEspot';
import styles from './FooterSecondDynamicLinksDesktop.module.scss';
import FooterSocialLinks from './FooterSocialLinks';
import { getLinksElement } from './LinkElement';

interface FooterSecondDynamicLinksDesktopProps {
	t: (key: string) => string;
	storeConf: StoreConfModel;
	espots?: Partial<{ secureInfo: any }>;
}

const FooterSecondDynamicLinksDesktop = ({ t, storeConf, espots }: FooterSecondDynamicLinksDesktopProps): React.JSX.Element => {
	const columns2 = getLinksElement(storeConf.footerLinkColumn?.[4]?.footerLinks);
	const columns3 = getLinksElement(storeConf.footerLinkColumn?.[5]?.footerLinks);
	const columns4 = getLinksElement(storeConf.footerLinkColumn?.[6]?.footerLinks);

	return (
		<div className={styles.container}>
			<div className="row">
				<div className="col-3">
					<div className={styles.bloc} data-test-id="bloc">
						<div className={styles.title}>{t('footer.qualityOfService')}</div>
						<div>
							<TrustedBadge />
						</div>
					</div>
					<div className={styles.bloc} data-test-id="bloc">
						<div className={styles.title}>{t('footer.paymentMethods')}</div>
						<div>
							<SecureInfoEspot espot={espots?.secureInfo} />
						</div>
					</div>
				</div>
				<div className="col-3">
					{columns2 && (
						<div className={styles.bloc} data-test-id="bloc">
							<div className={styles.title}>{storeConf.footerLinkColumn?.[4]?.title}</div>
							<ul>{columns2}</ul>
						</div>
					)}
					<div className={styles.bloc} data-test-id="bloc">
						<div className={styles.title}>{t('footer.followUsAlt')}</div>
						<div>
							<FooterSocialLinks conf={storeConf} />
						</div>
					</div>
				</div>
				<div className="col-3">
					{columns3 && (
						<div className={styles.bloc} data-test-id="bloc">
							<div className={styles.title}>{storeConf.footerLinkColumn?.[5]?.title}</div>
							<ul>{columns3}</ul>
						</div>
					)}
				</div>
				<div className="col-3">
					{columns4 && (
						<div className={styles.bloc} data-test-id="bloc">
							<div className={styles.title}>{storeConf.footerLinkColumn?.[6]?.title}</div>
							<ul>{columns4}</ul>
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default FooterSecondDynamicLinksDesktop;
